import { render, staticRenderFns } from "./MetaMetricsSettings.vue?vue&type=template&id=707d8bf2"
import script from "./MetaMetricsSettings.vue?vue&type=script&lang=js"
export * from "./MetaMetricsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports